var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"columns":_vm.columns,"create-route":{
      name: 'postalCodes.create'
    },"filters":_vm.filters,"pagination":true,"repository-func":_vm.repositoryFunc,"title":_vm.title,"identifier":"postalCodesTable"}})
}
var staticRenderFns = []

export { render, staticRenderFns }